/** トライアル帯モーダルからプランページへ遷移したときの `plansEntryRef` 値（ログ・識別用） */
export const PLANS_ENTRY_REF_SIGNUP_TRIAL_MODAL = 'signup_trial_modal';

export type PlansTrackingParams = {
    source: string;
    panelId?: string;
    /**
     * プランページ専用の流入識別子。クエリ `plansEntryRef` に付与される。
     * SPA 内遷移では document.referrer が空になりがちなため、ページアクセスログの metadata / referrer 補足に使う。
     */
    plansEntryRef?: string;
};

/**
 * トラッキング用のplansページURLを生成
 */
export function buildPlansUrlWithTracking(params: PlansTrackingParams): string {
    const searchParams = new URLSearchParams();
    // DBの session_context (VARCHAR(255)) に入れる想定の値を組み立て
    const sessionContextBase = params.panelId
        ? `${params.source}_${params.panelId}`
        : params.source;
    const sessionContext = sessionContextBase.slice(0, 255);

    // 決済セッション作成時に使われる sessionContext
    searchParams.set('sessionContext', sessionContext);

    // 追加の分析用パラメータ（必要に応じてフロント側で利用）
    searchParams.set('from', params.source);
    if (params.panelId) {
        searchParams.set('panel', params.panelId);
    }
    if (params.plansEntryRef) {
        searchParams.set('plansEntryRef', params.plansEntryRef);
    }

    return `/plans?${searchParams.toString()}`;
}

/**
 * プランページをトラッキング用パラメータ付きで新しいタブで開く
 */
export function openPlansWithTracking(params: PlansTrackingParams) {
    const url = buildPlansUrlWithTracking(params);
    window.open(url, '_blank', 'noopener,noreferrer');
}


